export default __webpack_public_path__ + "static/media/GLOTrackPink.94ee4934.svg";